const FaqData = {
    he: {
        // Heading is English for now, matches system_data_he (pending translation).
        title: 'Questions? Quick answers.',
        subtitle: 'Short answers on permits, violations, and closings. Detailed guides live on their own pages.',
        items: [
            {
                id: 'faq-1',
                question: 'כמה זמן לוקח לבנות אתר?',
                answer: 'אתר תדמית פשוט לוקח בדרך כלל 2-4 שבועות. אתר מורכב עם מערכת ניהול, חנות או אזור משתמשים, 4-8 שבועות. הכל תלוי בכמות הדפים, הפונקציות הנדרשות ומהירות אישורי הלקוח בדרך.'
            },
            {
                id: 'faq-2',
                question: 'מה כלול בבניית אתר?',
                answer: 'עיצוב מותאם, פיתוח מלא, חיבור לדומיין ואחסון, אופטימיזציה לנייד, SEO טכני בסיסי, ופאנל ניהול תוכן. בחבילות מסוימות גם אינטגרציות לכלים חיצוניים כמו WhatsApp, CRM ומייל.'
            },
            {
                id: 'faq-3',
                question: 'מה זה SEO ולמה זה חשוב לעסק שלי?',
                answer: 'SEO (אופטימיזציה למנועי חיפוש) זה מה שגורם לאתר שלך להופיע גבוה בתוצאות גוגל כשמישהו מחפש את השירות שלך. אתר שלא מופיע בגוגל פשוט לא קיים לרוב הלקוחות הפוטנציאליים. אנחנו עובדים על SEO טכני, תוכן, ובניית קישורים.'
            },
            {
                id: 'faq-4',
                question: 'עם אילו מערכות CRM אתם עובדים?',
                answer: 'אנחנו מתמחים ב-Zoho CRM אבל עובדים גם עם HubSpot, Monday CRM ומערכות מותאמות אישית. חשוב לנו לבחור את הכלי שמתאים לעסק, לא להפך.'
            },
            {
                id: 'faq-5',
                question: 'מה זה אוטומציה ואיך זה עוזר לי?',
                answer: 'אוטומציה היא חיבור בין מערכות כך שדברים קורים לבד, לדוגמה: לקוח ממלא טופס → מקבל מייל → נפתחת משימה במנהל הלידים → נשלחת הודעת וואטסאפ. זה חוסך שעות עבודה ידנית ומונע טעויות.'
            },
            {
                id: 'faq-6',
                question: 'האם אתם מציעים תמיכה שוטפת לאחר הפרויקט?',
                answer: 'כן. יש לנו חבילות ליווי חודשיות שכוללות תחזוקה, עדכונים, שינויי תוכן ותמיכה טכנית. לא עוזבים אתכם אחרי שהאתר עלה.'
            }
        ]
    },

    en: {
        title: 'Frequently Asked Questions',
        subtitle: 'Everything you want to know before working with us.',
        items: [
            {
                id: 'faq-1',
                question: 'How long does it take to build a website?',
                answer: 'A simple branding site usually takes 2-4 weeks. A more complex site with a management system, store, or user area takes 4-8 weeks. It depends on the number of pages, required features, and how quickly approvals come through.'
            },
            {
                id: 'faq-2',
                question: "What's included in a website build?",
                answer: 'Custom design, full development, domain & hosting setup, mobile optimization, basic technical SEO, and a content management panel. Some packages also include integrations with external tools like WhatsApp, CRM, and email.'
            },
            {
                id: 'faq-3',
                question: 'What is SEO and why does my business need it?',
                answer: "SEO (Search Engine Optimization) is what makes your website show up high in Google results when someone searches for your service. A website that doesn't appear on Google simply doesn't exist for most potential customers. We handle technical SEO, content, and link building."
            },
            {
                id: 'faq-4',
                question: 'Which CRM systems do you work with?',
                answer: 'We specialize in Zoho CRM but also work with HubSpot, Monday CRM, and custom built systems. The goal is to pick the right tool for your business, not the other way around.'
            },
            {
                id: 'faq-5',
                question: 'What is automation and how does it help me?',
                answer: 'Automation means connecting systems so things happen on their own, for example: a client fills out a form → gets an email → a task opens in your lead manager → a WhatsApp message is sent. It saves hours of manual work and prevents mistakes.'
            },
            {
                id: 'faq-6',
                question: 'Do you offer ongoing support after the project?',
                answer: 'Yes. We have monthly support packages that include maintenance, updates, content changes, and technical support. We do not walk away after the site goes live.'
            }
        ]
    }
};

function resolveLanguage(language) {
    return language === 'he' ? 'he' : 'en';
}

export function getFaqData(language) {
    const lang = resolveLanguage(language);
    return FaqData[lang] || FaqData.en;
}

export default FaqData;
